const axios = require('@websanova/vue-auth/drivers/http/axios.1.x.js');


axios['_setParams'] = function(req, params) {
    // console.log(req.params)
    req.params = Object.assign({}, req.params, params);
};
// console.log(axios)

module.exports = axios;
